import { render, staticRenderFns } from "./SlideDrawer.vue?vue&type=template&id=8685f9bc&scoped=true&lang=pug"
import script from "./SlideDrawer.vue?vue&type=script&lang=js"
export * from "./SlideDrawer.vue?vue&type=script&lang=js"
import style0 from "./SlideDrawer.vue?vue&type=style&index=0&id=8685f9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8685f9bc",
  null
  
)

export default component.exports